module.exports = __webpack_public_path__ + "static/media/essae-dig.5e1b452c.png";